import { ArrayMinSize, Matches } from 'class-validator';
import createCollectionResource from 'src/actions/shared/createResource';
import { matchesError } from 'src/models/DomainError';

export class KeywordGroup {
  id: string;
  @Matches(/\S/, { message: 'The keyword group must have a name' })
  label: string;
  languages?: string[];
  lastEditedAt: string;
  lastEditedBy: string;
  @ArrayMinSize(1, { message: 'There must be at least one keyword in this group' })
  phrases: string[];
}

const keywordGroupsResource = createCollectionResource<KeywordGroup>({
  name: 'keywordGroups',
  endpoint: 'v1/orgs/:orgId/keyword-groups/:id',
  type: KeywordGroup,
  options: {
    getErrorMessage: error => {
      if (matchesError(error, { attr: 'label', code: 'taken' })) {
        return 'Group name already taken';
      }
    },
  },
});

export default keywordGroupsResource;
